import { render, staticRenderFns } from "./ChartComboio.vue?vue&type=template&id=de9cde7a&lang=true&"
import script from "./ChartComboio.vue?vue&type=script&lang=js&"
export * from "./ChartComboio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports